import {Router} from "@angular/router";
import {NavigationVisitor} from "./NavigationVisitor";
import {inject, Injectable} from "@angular/core";
import {ErrorMessage} from "../error/ErrorMessage";
import {Exception} from "../error/Exception";
import {LogMessage} from "../error/LogMessage";
import {LogBook} from "../error/LogBook";

@Injectable({
    providedIn: "root"
})
export class ErrorNavigationVisitor implements NavigationVisitor {
    private router: Router = inject(Router);

    public visitErrorMessage(errorMessage: ErrorMessage, openNewTab: boolean = false): void {
        this.navigateToDetails(["/details/message", errorMessage.id], openNewTab);
    }

    public visitException(exception: Exception, openNewTab: boolean = false): void {
        this.navigateToDetails(["/details/exception", exception.id], openNewTab);
    }

    public visitLogMessage(logMessage: LogMessage, openNewTab: boolean = false): void {
        this.navigateToDetails(["/details/log", logMessage.id], openNewTab);
    }

    public visitLogBook(logBook: LogBook, openNewTab: boolean = false): void {
        this.navigateToDetails(["/details/logbook", logBook.id], openNewTab);
    }

    private navigateToDetails(urlPaths: string[], openNewTab: boolean = false): void {
        if (openNewTab) {
            this.openNewTab(urlPaths);
        } else {
            this.navigateInSameTab(urlPaths);
        }
    }

    private navigateInSameTab(urlPaths: string[]): void {
        this.router.navigate(urlPaths);
    }

    private openNewTab(urlPaths: string[]): void {
        const url = this.router.serializeUrl(
            this.router.createUrlTree(urlPaths)
        );

        window.open(url, '_blank');
    }
}
